module.exports = __webpack_public_path__ + "static/Cafe24Danjunghae-781424903060cfedd30654656cb06ee2.ttf";